interface ConvertToTitleCaseParams {
  text: string;
  splitBy: string;
  joinBy: string;
}

export const convertToTitleCase = ({
  text,
  splitBy,
  joinBy,
}: ConvertToTitleCaseParams) => {
  // Convert "mackay-street" to "Mackay Street"
  return text
    .split(splitBy)
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(joinBy);
};

export const convertToKebabCase = (text: string) => {
  // Convert "Mackay Street" to "mackay-street"
  return text?.toLowerCase().replace(/ /g, '-');
};
